/**
 * Production-safe logging utility
 * Logs only in development, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENVIRONMENT === 'development';

export const devLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log('[DEV]', ...args);
  }
};

export const devError = (...args: any[]) => {
  if (isDevelopment) {
    console.error('[DEV ERROR]', ...args);
  }
};

export const devWarn = (...args: any[]) => {
  if (isDevelopment) {
    console.warn('[DEV WARN]', ...args);
  }
};

// For debugging API responses (sanitizes sensitive data)
export const devLogAPI = (label: string, data: any) => {
  if (isDevelopment) {
    console.log(`[DEV API] ${label}:`, data);
  }
};

// For debugging without sensitive data
export const devLogSafe = (label: string, data: any) => {
  if (isDevelopment) {
    // Remove sensitive fields before logging
    const sanitized = sanitizeForLogging(data);
    console.log(`[DEV SAFE] ${label}:`, sanitized);
  }
};

// Helper to remove sensitive data
const sanitizeForLogging = (obj: any): any => {
  if (!obj || typeof obj !== 'object') return obj;
  
  const sensitive = ['password', 'token', 'secret', 'key', 'auth', 'credential'];
  const sanitized = { ...obj };
  
  Object.keys(sanitized).forEach(key => {
    if (sensitive.some(s => key.toLowerCase().includes(s))) {
      sanitized[key] = '[REDACTED]';
    } else if (typeof sanitized[key] === 'object') {
      sanitized[key] = sanitizeForLogging(sanitized[key]);
    }
  });
  
  return sanitized;
};

export default { devLog, devError, devWarn, devLogAPI, devLogSafe };